import React from 'react';
import { Button, useMediaQuery } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

function InstitutionButton({ institution }) {
    const handleClick = () => {
        if (institution === 'legal') {
            window.open("https://thelegalindustry.com/", "_blank");
        } else if (institution === 'health') {
            window.open("https://healthindustryreviews.com/", "_blank");
        } else if (institution === 'corporate') {
            window.open("https://thecorporatereviews.com/", "_blank");
        }
    };      
    const isMobile = useMediaQuery('(max-width: 768px)');


    return (
        <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: isMobile ? '5px' : '14px' }} />}
        sx={{
            backgroundColor: 'transparent',
            color: 'white',
            borderColor: 'white',
            borderRadius: '14px',
            textTransform: 'none', // evita forzar el texto a mayúsculas
            padding: isMobile ? '4px 10px' : '6px 16px',
            fontSize: isMobile ? '0.8rem' : '0.875rem', // Ajusta la fuente si lo requieres

            // Hover
            '&:hover': {
            borderColor: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },

            // Foco
            '&.Mui-focusVisible, &:focus': {
            borderColor: '#F67147',
            },

            // Activo (al presionar)
            '&:active': {
            borderColor: '#F67147',
            }
        }}
        >
            {institution === 'legal'
            ? (isMobile ? 'LIR' : 'The Legal Industry Reviews')
            : institution === 'health'
            ? (isMobile ? 'HIR' : 'The Health Industry Reviews')
            : institution === 'corporate'
            ? (isMobile ? 'CORP' : 'The Corporate Industry Reviews')
            : ''}
        </Button>
    );
}

export default InstitutionButton;
